export default "__VITE_ASSET__aaY0Nwye__"